/**
 * Statistics API Funktionen
 */

import { apiClient } from '../api-client';

// ===========================================
// GENERATION TIME STATISTICS
// ===========================================

export interface GenerationTimeStats {
  average_duration: number;
  sample_size: number;
  unit: string;
}

/**
 * Statistiken zur durchschnittlichen Generierungszeit abrufen
 */
export async function getGenerationTimeStats(): Promise<GenerationTimeStats> {
  const response = await apiClient.get('/api/v2/statistics/generation-time');
  return response.data;
}
